const ufeApi = require('services/api/ufeApi');

function getPersonalizedPromotions() {
    const url = '/api/users/profiles/current/promotions?includeBCCData=true';

    return ufeApi
        .makeRequest(url, { method: 'GET' })
        .then(data => data.errorCode ? Promise.reject(data) : data);
}
module.exports = { getPersonalizedPromotions };
